import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import AdFileOps from './AdFileOps';
import {JsonAdSummary} from '../../ext/lib/types';
import UserContext from '../common/UserContext';
import {handleResponse} from '../../ext/common/rest-api-helper';
import {jsonDateTimeFormat} from '../../ext/lib/temporal';
import {useState} from 'react';
import * as R from 'ramda';

type Props = {ad: JsonAdSummary};

const ProgramAdActions: React.FC<Props> = ({ad}) => {
  const {apiToken} = React.useContext(UserContext);
  const [isProgrammed, setIsProgrammed] = useState(Boolean(ad.programmedAt));

  async function handleProgrammedChange(e: React.ChangeEvent<HTMLInputElement>): Promise<void> {
    const changeEventAdKey = (e: React.ChangeEvent<HTMLInputElement>) => ({
      adUser: e.target.dataset.user as string,
      adKey: e.target.dataset.key as string
    });

    function setAdProgrammed(adUser: string, adKey: string, isProgrammed: boolean): Promise<void> {
      return fetch(`/api/v1/requests/${btoa(adUser)}/${adKey}`, {
        method: 'PATCH',
        headers: {
          'Authorization': apiToken || 'missing-token',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          isProgrammed
           ? {programmedAt: jsonDateTimeFormat(new Date())}
           : {programmedAt: ''}
        )
      }).then(R.pipe(
        handleResponse as (_: Response) => Promise<void>,
        R.otherwise(err => {
          console.error('Unable to set ad programmed: %o', err);
          alert('Unable to set ad programmed. Try again or contact support');
        })
      ));
    }

    const {adUser, adKey} = changeEventAdKey(e);
    const checked = R.path(['target', 'checked'], e) as boolean;
    setIsProgrammed(checked);
    return setAdProgrammed(adUser, adKey, checked);
  }

  return <>
    <FormControlLabel
      label="Programmed"
      control={
        <Switch
          checked={isProgrammed}
          color="primary"
          inputProps={{
            // @ts-ignore
            'data-user': ad.userEmailAddress,
            'data-key': ad.adKey
          }}
          onChange={handleProgrammedChange}
        />
      }
    />
    {/* TODO: remove upload ad operation from program view */}
    <AdFileOps
      adKey={ad.adKey}
      adFileKey={ad.adFileKey}
      userAuthToken={apiToken || 'missing-token'}
      userEmailAddress={ad.userEmailAddress}
    />
  </>;
};
export default ProgramAdActions;
